module.exports = __webpack_public_path__ + "media/evolve/assets/icons/floorplans/elevator-14ec6b113cb7033e79b69a19a32911a5.svg";